import { useNeoletterUserProfile } from "shared/api/neoletter-user-profile/useNeoletterUserProfile"
import { useColorSchemeController } from "shared/lib/color-scheme/useColorScheme"
import { useEtrackerUserSegments } from "shared/lib/etracker/useEtrackerUserSegments"
import { useAuth } from "shared/lib/useAuth"

import { useExternalDimensioningModelsQuery } from "entities/dim-configuration/graphql/external-dimensioning.queries.generated"
import { useProductConfigurationModelsQuery } from "entities/dim-configuration/graphql/product-configuration.queries.generated"
import { useInflationSurchargeQuery } from "entities/projects/graphql/inflation-surcharge/queries.generated"
import { usePriceListsQuery } from "entities/projects/graphql/price-lists/queries.generated"
import { useActiveProjectPermissionsPrefetch } from "entities/projects/model/useActiveProjectPermissionsPrefetch"
import { useProjectPhases } from "entities/projects/model/useProjectPhases"
import { useGlobalSearchKeyboardShortcut } from "widgets/global-search-overlay/model/useGlobalSearchKeyboardShortcut"

import { useAPIHealthMonitor } from "./useAPIHealthMonitor"

export function useApp() {
  const { isAuthenticated } = useAuth()

  useColorSchemeController()
  useAPIHealthMonitor()
  useProductConfigurationModelsQuery()
  useExternalDimensioningModelsQuery()
  useProjectPhases()
  useInflationSurchargeQuery({ skip: !isAuthenticated })
  usePriceListsQuery({ skip: !isAuthenticated })
  useNeoletterUserProfile()
  useActiveProjectPermissionsPrefetch()
  useGlobalSearchKeyboardShortcut()
  useEtrackerUserSegments()
}
